<div class="row" *ngIf="this._state.username">
  <div class="col-sm-12 col-md-6 col-lg-4" *ngFor="let item of this._state.pilotList; let i = index">
    {{i+1}}.{{item.area}} <small>({{item.name}})</small>
    <app-videojs [id]="i+1"></app-videojs>
  </div>
</div>
